var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegalCase2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 129,
    viewBox: "0 0 127 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1701_3007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 31.1047C10 19.4489 19.4489 10 31.1047 10H87.2758C98.9317 10 108.381 19.4489 108.381 31.1047V88.8953C108.381 100.551 98.9317 110 87.2758 110H31.1047C19.4489 110 10 100.551 10 88.8953V31.1047Z",
    fill: "#FBF8F0"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 30,
    width: 60,
    height: 60,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1701_3007",
    x: 0.151122,
    y: 0.151122,
    width: 126.521,
    height: 128.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.03491,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1701_3007"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.22095,
    dy: 4.22095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51746
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1701_3007"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1701_3007",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1701_3007",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1701_3007",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAEy0lEQVR4nO2dW4xdUxjHfzVVaVNEaQQhx31CownBPCAkE0QkEtpI8DCh0sQlHkTaul8TKd4QQowHGpEIEhLNPBkSfWkoWoQ6VLWhiraubeqTL1mTcDJnzj5nr8u3916/5P8ymcn8v/86e6291llrb8hkMplMphocASwH3gI2ArudNrqfLXe/k/HMAuApYB8gPbTP/a7+TcYDlwI/FQi+UzuAS3ILlOMaYO8A4f/3arg+N8L/aZcIVAJLvdWecQNBSxept9ozZiBo6SL1VntaBoKWLlJvjcDiONCmQVgcB8ZpEBbHgTEahMVxoEXDaBsIvZH9v8VxYJwGMmYg+Eb2/xbHgRYNpW0g/Eb2/5bGgXEazJiBBmhk/29pHGilDiGTyWQymUwmk8lkYjEMrDUwEVvrvDSG2cAK4E8D4U9Jd989Csyh5ugnbYOBwKWLNtT5argC+NVAyNJDe4CrqVmXo5f3PwbClT70bB26JN2jP2kgTBlQk1U+Z3C08f5eCmoTcBwV4wRgi4HwxJO2uJoqwbHA1wZCkwCNcDzGOQrYbCAsCaTNrkaTzAXWGQhJAms9MB9jHAC8biAciaS3gSEM8XCiID4HXgTuBK4FrgRGgaXADcBDwKvANwH+t9ZsAi14f8TQtwJ3DXBXcqZnH/td7Uk5EtgecYng9hKz04sDeNruMkjGa5HC/wpYVNLrbYG8aQZJuDxS+Os8LQc8E9CjZhGVeZEmW22Pl3jINalvY9+aPhjpS5IzPHr+MbBfzSQK2h3sitAAj/U5DzkHuAV4ALgfuBW40E0QF0bwuyvWyukjEYrZCRxcMPgbe5wz+A14L4JncdkE5XD3gKTQhawu4GW+m5GKIe12GQXjjkiFnFTgk/+OgcCnk2YUjE0RCvi0gI+bDQTdTV8As0KEf14gw6MdKjLhGpnm76YkBqRZeeeFQGZ9IwakWXllyN2Z5AagUAY/+16uHgn4afGNGNG5Pou6J6DRiQ7pPqKZ7n4mekiMSDPzRqyJjPS4dA8yEGxR6dqTF+aUfHSkzwaYZyDYotrra2fdosjGZ+IQA8H2o9PxwNLAJkc7NBOzZ7j/tzQPmJJmV5r7En7iB0EM6V488EpuAAZtAM2uNKF3N/tGDOldHwV9FNjkRIf0y/NerKzAPEBcdqWJvdfzswKeWm6bihiXZleaHQmMDxfwdZmxg37TSbMrzV8JjD9Z0NvZwMcGgu4mza40fycwvqeP7ShD7mp4GvjAfSGi75R5H3gOuA44K1EDaHal+SWR+TX4Qxfxfk+0LF2a7xI1gABL8MeHCfxrdqX5JGED/AGc76MI4OUE/nV8Ks2bCRtAXBfoY+/l3Qm8v+HBN08kbgBxh7xXu+XoQbkqge/HfTTAMgMNIE4/AKuAQweo47QEfvWUTmmGDQQv09zeTbqVWn1Z22LgGPeNmeow4GS3N3SZe7NeigOEp+CJ7w2ELhXTNmr2jGepmJ732QAXGShIKqYLfDbArJo+fkACroJ63x96k4HCpCLS9xp758CaPwdCPKkd8kFPSwwUKMalp/WDssZAkWJULxGBBe7gdOpixZi+jPl4sxMjHPuUCklfuX4qkRkJeGZAKqSdvrei97vAVadnw8kAyw0+D5NnMplMhubwLzrciUzDYqVwAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalCase2);
export default __webpack_public_path__ + "static/media/LegalCase2.67d44c97057e6982b82063c6a583dd7d.svg";
export { ForwardRef as ReactComponent };